import _ from "lodash"
import React from "react"
import { enumMessages } from "@/utils/MessageUtils"

const AdPlatformTypeOptions = _.map(enumMessages("RegistrationAdPlatformType"), (message) => {
  return {
    value: message.value,
    label: message.message,
  }
})

class RegistrationAdPlatformTypeInfo extends React.Component {
  render() {
    const { value } = this.props
    let type = ""
    AdPlatformTypeOptions.forEach((option) => {
      if (value === option.value) {
        type = option.label
      }
    })

    return <span>{type}</span>
  }
}

export default RegistrationAdPlatformTypeInfo
